module.exports = __webpack_public_path__ + "static/media/centralised.73958e66.svg";